function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00025 20.001C6.27525 20.001 6.55025 19.888 6.74725 19.665L14.7472 10.665C15.0843 10.286 15.0843 9.716 14.7472 9.337L6.74725 0.337C6.38125 -0.077 5.74925 -0.115 5.33625 0.254C4.92325 0.62 4.88625 1.253 5.25325 1.665L12.6623 10.001L5.25325 18.337C4.88625 18.749 4.92325 19.382 5.33625 19.748C5.52625 19.918 5.76425 20.001 6.00025 20.001Z",
  fill: "#637381"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 5,
  y: 0,
  width: 10,
  height: 21
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00025 20.001C6.27525 20.001 6.55025 19.888 6.74725 19.665L14.7472 10.665C15.0843 10.286 15.0843 9.716 14.7472 9.337L6.74725 0.337C6.38125 -0.077 5.74925 -0.115 5.33625 0.254C4.92325 0.62 4.88625 1.253 5.25325 1.665L12.6623 10.001L5.25325 18.337C4.88625 18.749 4.92325 19.382 5.33625 19.748C5.52625 19.918 5.76425 20.001 6.00025 20.001Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgRightIcon = function SvgRightIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right_icon.ab77aaaf.svg";
export { ForwardRef as ReactComponent };